export const ClientSubscriptionPage = {
  en: {
    'My subscription': 'My subscription',
    Cost: 'Cost',
    'Subscription active': 'Active',
    'Subscription suspended': 'Payment failed',
    'Subscription suspended explanation':
      'The last charge did not go through. As soon as a payment succeeds, a new card is issued and the subscription becomes active again.',
    'Current card valid until': 'Current card valid until',
    'Cancel subscription': 'Cancel subscription',
    'Cancel subscription notice':
      'The current card stays usable until the end of its term. No further charges will be made.',
    'Cancel subscription dialog title': 'Cancel the subscription?',
    'Cancel subscription dialog description':
      'Automatic charges will stop. The card you already paid for stays usable until the end of its term.',
    'Keep subscription': 'Keep it',
    'Cancellation requested':
      'The cancellation request has been sent. The status will update once the payment provider confirms it.',
    'No active subscription': 'You have no active subscription.',
    'Resubscribe offer title': 'Return to your previous subscription',
    'Resubscribe offer description':
      'You can resume «<b>{{name}}</b>» at its old price of <b>{{price}}</b> per month until <b>{{date}}</b>.',
    Resubscribe: 'Resume',
    'Choose a subscription': 'Choose a subscription',
  },
  uk: {
    'My subscription': 'Моя підписка',
    Cost: 'Вартість',
    'Subscription active': 'Активна',
    'Subscription suspended': 'Платіж не пройшов',
    'Subscription suspended explanation':
      'Останнє списання не пройшло. Щойно платіж буде успішним, ви отримаєте нову картку, а підписка знову стане активною.',
    'Current card valid until': 'Поточна картка діє до',
    'Cancel subscription': 'Скасувати підписку',
    'Cancel subscription notice':
      'Поточна картка діятиме до кінця свого терміну. Подальших списань не буде.',
    'Cancel subscription dialog title': 'Скасувати підписку?',
    'Cancel subscription dialog description':
      'Автоматичні списання припиняться. Уже оплачена картка діятиме до кінця свого терміну.',
    'Keep subscription': 'Залишити',
    'Cancellation requested':
      'Запит на скасування надіслано. Статус оновиться після підтвердження платіжним сервісом.',
    'No active subscription': 'У вас немає активної підписки.',
    'Resubscribe offer title': 'Повернутися до попередньої підписки',
    'Resubscribe offer description':
      'Ви можете поновити «<b>{{name}}</b>» за старою ціною <b>{{price}}</b> на місяць до <b>{{date}}</b>.',
    Resubscribe: 'Поновити',
    'Choose a subscription': 'Обрати підписку',
  },
};
